import { Box, Typography } from "@mui/material"

const GoalsCell = (props: any) => {
  const { row, renderedCellValue } = props

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 10px",
      }}
    >
      <Typography>{renderedCellValue}</Typography>
    </Box>
  )
}

export default GoalsCell
